import { useState, useEffect } from 'react';
import { getUnifyPosProviders } from '@services/onboarding';
import { CONNECTION_TYPE } from '../constants';

/**
 * Fetches and returns the POS provider list
 * Filters for valid connection types (OAuth, plug-and-play, partner-lead)
 *
 * @param {boolean} businessDetailsCompleted - Whether business details are completed
 * @param {Object} currentShop - Current shop object
 * @returns {Object} { posList, loading, error }
 */
export const usePOSProviders = (businessDetailsCompleted, currentShop) => {
	const [posList, setPosList] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	useEffect(() => {
		const hasInventorySource = currentShop?.stockInventorySource?.pointOfSale ||
			currentShop?.inventorySources?.some(source => source.kind === 'stock' && source.pointOfSale);

		const shouldFetch = (businessDetailsCompleted || hasInventorySource) && posList.length === 0;

		if (shouldFetch) {
			setLoading(true);
			getUnifyPosProviders()
				.then((providers) => {
					const validProviders = providers.filter(
						(pos) =>
							pos.connection &&
							[CONNECTION_TYPE.OAUTH, CONNECTION_TYPE.PLUG_PLAY, CONNECTION_TYPE.PARTNER_LEAD].includes(pos.connection)
					);
					setPosList(validProviders);
					setLoading(false);
				})
				.catch(() => {
					setError('Failed to load POS providers. Please refresh the page.');
					setLoading(false);
				});
		}
	}, [businessDetailsCompleted, currentShop, posList.length]);

	return {
		posList,
		loading,
		error
	};
};
